"use client"
import { useState, useEffect, useContext } from "react"
import {
  IconButton,
  Modal,
  Typography,
  Box,
  Paper,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Chip,
  Card,
  CardContent,
  alpha,
  Zoom,
} from "@mui/material"

// Icons
import { Close as CloseIcon } from "@mui/icons-material"
import DescriptionIcon from "@mui/icons-material/Description"
import PersonIcon from "@mui/icons-material/Person"
import BusinessIcon from "@mui/icons-material/Business"
import AttachMoneyIcon from "@mui/icons-material/AttachMoney"
import PaymentIcon from "@mui/icons-material/Payment"
import CalendarTodayIcon from "@mui/icons-material/CalendarToday"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import StoreIcon from "@mui/icons-material/Store"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import HomeIcon from "@mui/icons-material/Home"
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"
import InventoryIcon from "@mui/icons-material/Inventory"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"

import { ErpContext } from "../../context/ErpContext.js"
import SpinnerLading from "../misc/SpinnerComponent.js"

const ModalViewTablaIngreso = ({ openModal, handleCloseModal, selectedTransaccion }) => {
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] = useState(null)
  const [transaccionItems, setTransaccionItems] = useState([])
  const [calculatedTotal, setCalculatedTotal] = useState(0)
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(0)
  const [porcentajeDescuento, setPorcentajeDescuento] = useState(0)
  const [itemsMap, setItemsMap] = useState({})
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(0)
  const [transaccionModificable, setTransaccionModificable] = useState([])
  const [loading, setLoading] = useState(true)

  const { getTransaccionItemID, getEntidadByID, getItemById ,isNavbarCollapsed,
  } = useContext(ErpContext)

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (selectedTransaccion) {
          console.log(selectedTransaccion)
          // Obtener la entidad cliente
          const entidadCliente = await getEntidadByID(selectedTransaccion.idEntidadNumero)
          setSelectedTransaccionEntidad(entidadCliente)

          // Obtener los ítems de la transacción
          const items = await getTransaccionItemID(selectedTransaccion.id)
          console.log("items de la transacción:", items)

          // Obtener los detalles de cada Item
          const itemsWithDetails = await Promise.all(
            items.map(async (item) => {
              const itemDetails = await getItemById(item.idItem) // Obtener detalles del Item
              return {
                ...item, // Mantener los datos de la transacción
                codigo: itemDetails.codigo, // Agregar el código del Item
                descripcion: itemDetails.descripcion, // Agregar la descripción del Item
              }
            }),
          )

          console.log("items con detalles:", itemsWithDetails)
          setTransaccionItems(itemsWithDetails)

          // Crear el mapa de ítems
          const itemsMap = itemsWithDetails.reduce((map, item) => {
            map[item.idItem] = {
              codigo: item.codigo,
              descripcion: item.descripcion,
            }
            return map
          }, {})

          setItemsMap(itemsMap)

          // Calcular montos
          const { montoTotal, impuestos = [], montoDescuento = 0, porcentajeDescuento = 0 } = selectedTransaccion

          // Calcular el monto total sin impuestos
          const totalSinImpuestos = impuestos.reduce((total, impuesto) => {
            return total - (impuesto.montoTotal || 0)
          }, montoTotal)

          // Aplicar descuentos
          const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento
          const totalFinal = totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100)

          // Actualizar estados
          setCalculatedTotal(totalFinal)
          setTotalMontoDescuento(montoDescuento)
          setPorcentajeDescuento(porcentajeDescuento)
          setMontoSinImpuesto(totalSinImpuestos)
        }
      } catch (error) {
        console.error("Error al cargar los datos:", error)
      } finally {
        setLoading(false) // Ocultar el spinner independientemente del resultado
      }
    }

    fetchData()
  }, [selectedTransaccion])

  // Renderiza el spinner mientras está cargando
  if (loading) {
    return <SpinnerLading />
  }

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-transaccion-titulo"
      aria-describedby="modal-transaccion-descripcion"
    >
      <Box
        className="modal-background"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "100%",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <Zoom in={openModal} timeout={300}>
          <Paper className="modal-container">
            {/* Header */}
            <Box
              sx={{
                bgcolor: "#5b5b5f",
                color: "white",
                p: 2,
                borderTopLeftRadius: 8,
                borderTopRightRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 2,
                position: "sticky",
                top: 0,
                zIndex: 10,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <ReceiptLongIcon />
                <Typography
                  variant="h6"
                  component="h2"
                  className="modal-title"
                  sx={{ color: "white", borderBottom: "none", m: 0, p: 0 }}
                >
                  Detalles de Ingreso #{selectedTransaccion?.id}
                </Typography>
              </Box>
              <IconButton
                onClick={handleCloseModal}
                sx={{ color: "white" }}
                className="close-button"
                aria-label="cerrar"
              >
                <CloseIcon />
              </IconButton>
            </Box>

            {/* Content */}
            <Box sx={{ p: 3 }}>
              {/* Información principal */}
              <Grid container spacing={3} sx={{ mb: 3 }}>
                {/* Datos ERP */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #5b5b5f",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <BusinessIcon sx={{ color: "#5b5b5f" }} />
                        Datos ERP
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <CalendarTodayIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Fecha:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.createdAt || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Tipo:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.idTipoTransaccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <StoreIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Negocio:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.negocio || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <AccountCircleIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Usuario:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.usuario || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Ubicación:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.ubicacion || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Entidad */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid rgb(244, 177, 14)",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PersonIcon sx={{ color: "rgb(244, 177, 14)" }} />
                        Datos de la Entidad
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <PersonIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Nombre:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.descripcionEntidad} {selectedTransaccion?.apellido || ""}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <DescriptionIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            DNI/CUIT:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.dniCuitCuil || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <HomeIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Dirección:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.direccion || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Localidad:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.localidad || "N/A"}
                          </Typography>
                        </Box>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                          <LocationOnIcon fontSize="small" color="action" />
                          <Typography variant="body2" className="transaction-detail-label">
                            Provincia:
                          </Typography>
                          <Typography variant="body2" className="transaction-detail-value">
                            {selectedTransaccion?.provincia || "N/A"}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Datos Financieros */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #4CAF50",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <AttachMoneyIcon sx={{ color: "#4CAF50" }} />
                        Datos Financieros
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {/* Total */}
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            p: 1,
                            bgcolor: alpha("#4CAF50", 0.1),
                            borderRadius: 1,
                          }}
                        >
                          <AttachMoneyIcon fontSize="small" sx={{ color: "#4CAF50" }} />
                          <Typography variant="body1" className="transaction-detail-label" fontWeight="bold">
                            Total:
                          </Typography>
                          <Typography variant="body1" className="value">
                            {new Intl.NumberFormat("es-AR", {
                              style: "currency",
                              currency: "ARS",
                            }).format(selectedTransaccion?.montoTotal || 0)}
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                {/* Medios de Pago */}
                <Grid item xs={12} md={3}>
                  <Card
                    elevation={2}
                    className="contenedorDatosModal"
                    sx={{
                      height: "100%",
                      borderLeft: "4px solid #2196F3",
                      borderRadius: 2,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                        transform: "translateY(-2px)",
                      },
                    }}
                  >
                    <CardContent>
                      <Typography
                        variant="subtitle1"
                        className="section-title"
                        sx={{
                          mb: 2,
                          fontWeight: "bold",
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                        }}
                      >
                        <PaymentIcon sx={{ color: "#2196F3" }} />
                        Medios de Pago
                      </Typography>

                      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                        {selectedTransaccion?.pagos && selectedTransaccion.pagos.length > 0 ? (
                          selectedTransaccion.pagos.map((pago, idx) => (
                            <Box key={idx} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                              <PaymentIcon fontSize="small" color="action" />
                              <Typography variant="body2" className="transaction-detail-label">
                                {pago.descripcion}:
                              </Typography>
                              <Typography variant="body2" className="value">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(pago.monto || 0)}
                              </Typography>
                            </Box>
                          ))
                        ) : (
                          <Typography variant="body2" sx={{ fontStyle: "italic" }}>
                            No hay información de pagos
                          </Typography>
                        )}
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>

              {/* Descripción */}
              {selectedTransaccion.descripcion && (
                <Card
                  elevation={2}
                  sx={{
                    mb: 3,
                    p: 2,
                    borderRadius: 2,
                    borderLeft: "4px solid #5b5b5f",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    },
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      mb: 1,
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <DescriptionIcon sx={{ color: "#5b5b5f" }} />
                    Descripción
                  </Typography>
                  <Typography variant="body1">
                    {selectedTransaccion.afectaCuentaCorriente ? (
                      <>
                        <span style={{ color: "#4CAF50", fontWeight: "bold" }}>
                          [CC]
                        </span>
                        <span style={{ color: "black" }}> {selectedTransaccion.descripcion}</span>
                      </>
                    ) : (
                      selectedTransaccion.descripcion
                    )}
                  </Typography>
                </Card>
              )}

              {/* Tabla de Ítems */}
              {transaccionItems.length > 0 && (
                <Box sx={{ mb: 3 }}>
                  <Typography
                    variant="h6"
                    className="items-title"
                    sx={{
                      mb: 2,
                      display: "flex",
                      alignItems: "center",
                      gap: 1,
                      color: "#5b5b5f",
                    }}
                  >
                    <InventoryIcon />
                    Ítems de la Transacción
                  </Typography>

                  <TableContainer
                    component={Paper}
                    elevation={3}
                    className="tableContainerItemList"
                    sx={{
                      borderRadius: 2,
                      overflow: "hidden",
                      maxHeight: 300,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                      },
                    }}
                  >
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell className="table-header-cell">Descripción</TableCell>
                          <TableCell align="right" className="table-header-cell">
                            Cantidad
                          </TableCell>
                          <TableCell align="right" className="table-header-cell">
                            Precio Unitario
                          </TableCell>
                          <TableCell align="right" className="table-header-cell">
                            Descuento
                          </TableCell>
                          <TableCell align="right" className="table-header-cell">
                            Total
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {transaccionItems.map((item, index) => {
                          const precio = item.precio || 0
                          const cantidad = item.cantidad || 0
                          const descuento = item.porcentajeDescuento || 0
                          const totalItem = (precio * cantidad * (1 - descuento / 100)).toFixed(2)

                          const foundItem = itemsMap[item.idItem]

                          return (
                            <TableRow
                              key={`${item.idTransaccion}-${item.idItem}-${index}`}
                              className={index % 2 === 0 ? "row-color-default" : "row-color-alt"}
                              sx={{
                                transition: "background-color 0.2s ease",
                                "&:hover": {
                                  backgroundColor: alpha("#5b5b5f", 0.05),
                                },
                              }}
                            >
                              <TableCell className="table-cell">
                                <Typography variant="body2" fontWeight="medium">
                                  {foundItem ? `${foundItem.codigo} - ${foundItem.descripcion}` : "No encontrado"}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <Chip label={cantidad} size="small" color="primary" variant="outlined" />
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {new Intl.NumberFormat("es-AR", {
                                  style: "currency",
                                  currency: "ARS",
                                }).format(precio)}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                {descuento > 0 ? (
                                  <Chip label={`${descuento}%`} size="small" color="secondary" variant="outlined" />
                                ) : (
                                  "0%"
                                )}
                              </TableCell>
                              <TableCell align="right" className="table-cell">
                                <span className="value">
                                  {new Intl.NumberFormat("es-AR", {
                                    style: "currency",
                                    currency: "ARS",
                                  }).format(totalItem)}
                                </span>
                              </TableCell>
                            </TableRow>
                          )
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}

              {/* Acciones */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  borderTop: "1px solid #eee",
                  pt: 2,
                }}
              >
                <Button
                  variant="contained"
                  startIcon={<PictureAsPdfIcon />}
                  sx={{
                    bgcolor: "#5b5b5f",
                    "&:hover": {
                      bgcolor: alpha("#5b5b5f", 0.9),
                    },
                  }}
                >
                  Generar PDF
                </Button>
              </Box>
            </Box>
          </Paper>
        </Zoom>
      </Box>
    </Modal>
  )
}

export default ModalViewTablaIngreso
